module.exports = __webpack_public_path__ + "img/国防科技大学电子科学学院.a23acef4.png";